module.exports = __webpack_public_path__ + "static/clubewatt-logo-0bb8f9bfd291814300832dc6d82a41b2.svg";